import { useQuery } from "@tanstack/react-query";
import { fetchHomeIndex } from "../../../services/newApi";
import { formatAmount } from "../../../functions/functions";
import Loader from "../../../components/Loader";
import ErrorWrapper from "../../../components/ui/wrappers/ErrorWrapper";

const regulations = [
    "Agréé PSFP — Autorité des Marchés Financiers (n° FP-2024-7)",
    "Supervisé par l'ACPR par son activité d'octroi de prêts",
];

const formatRate = (value) => {
    const rate = parseFloat(value);
    return Number.isFinite(rate) ? `${rate.toFixed(2).replace(".", ",")} %` : "—";
};

// Arrondi a la centaine inferieure : 738 prets -> "plus de 700 prets".
const roundDownToHundred = (value) => {
    const count = parseInt(value, 10);
    return Number.isFinite(count) ? Math.floor(count / 100) * 100 : null;
};

const buildFigures = (data) => {
    const loansCount = roundDownToHundred(data.NbProjetsFinances);

    return [
        {
            value: formatRate(data.TauxMoyenPret),
            label: "Taux moyen brut des prêts en 2026",
        },
        {
            value: "0 €",
            label: "Frais sur versement, gestion et sortie",
        },
        {
            value: formatAmount(data.Sommefinancee),
            label: loansCount
                ? `Financés depuis 2015, plus de ${loansCount.toLocaleString("fr-FR")} prêts`
                : "Financés depuis 2015",
        },
    ];
};

const KeyFigures = () => {
    const { isPending, data, error, isError } = useQuery({
        queryKey: ["index-homepage"],
        queryFn: fetchHomeIndex,
    });

    const renderFigures = () => {
        if (isPending) {
            return (
                <div className="border-y border-gray-200 py-10">
                    <Loader />
                </div>
            );
        }

        if (isError || !data) {
            return (
                <div className="border-y border-gray-200 py-10">
                    <ErrorWrapper error={error?.message || ""} />
                </div>
            );
        }

        return (
            <div className="grid grid-cols-1 divide-y divide-gray-200 border-y border-gray-200 py-10 md:grid-cols-3 md:divide-x md:divide-y-0">
                {buildFigures(data).map(({ value, label }) => (
                    <div key={label} className="px-7 py-6 text-center md:py-0">
                        <p className="text-4xl font-bold text-secondary">{value}</p>
                        <p className="mt-2 text-sm leading-snug text-gray-600">{label}</p>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <section className="py-8 md:py-10">
            {renderFigures()}

            <div className="mt-8 flex flex-col items-center justify-center gap-4 rounded-2xl bg-secondaryDark px-6 py-4 text-center md:flex-row md:gap-32">
                {regulations.map((text) => (
                    <p key={text} className="flex items-center gap-2 text-sm text-secondaryExtraLight">
                        <span className="h-1.5 w-1.5 flex-shrink-0 rounded-full bg-accent" />
                        {text}
                    </p>
                ))}
            </div>
        </section>
    );
};

export default KeyFigures;
